// Pricing page overrides for compact cards
export const PRICING_LUXURY_PLAN_IDS = ['prod_itr_af_updated'];
export const PRICING_UTM_REF_BUY_NOW = 'plan-card_Buy+Now';
export const PRICING_UTM_REF_KNOW_MORE = 'plan-card_Know+more';
export const PRICING_LUXURY_HEADING = 'File Your Updated Return (ITR-U)';
export const PRICING_LUXURY_FEATURES = [
  'Dedicated CA to file your ITR-U accurately',
  'End-to-end handling of corrections, disclosures & compliance',
  'Support via chat, call & video consultation',
  'Ideal for missed filings or correcting past returns',
  'Includes guidance on tax dues, interest & penalties',
];
